
import { CustomersPage } from "./CustomersPage";

export default function Customers() {
  return <CustomersPage />;
}
